// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__23tmQ","main":"Layout_main__1e6Gj"};